const { ANDES_MONEY_DECIMAL_SEPARATOR } = require('../../../../../../constants/commons');

const DECIMALS = {
    ',': ANDES_MONEY_DECIMAL_SEPARATOR.COMMA,
    '.': ANDES_MONEY_DECIMAL_SEPARATOR.DOT,
}

export const getDecimalSeparator = (char) => DECIMALS[char] || ANDES_MONEY_DECIMAL_SEPARATOR.COMMA